var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 32,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAAXNSR0IB2cksfwAAAMlQTFRFAAAAKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKfo254ubvt8DYcICxxszg////jJrBRVqa8fL3Nk6SU2ehYXSpm6bIqbPQ1NnoKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKKEGKDIfNHgAAAEN0Uk5TACqO1/j/9s6DHgaU/X0Cu5+VbSv87xKPcbL50dL////////////////////Pq2Qd9+kMWgOdf27lWBNpr8zdyKheCdxn0u0AAADmSURBVHicrZNJW8IwEIYHy7RVrKhQN2xsp3vBFTcEFfz/P4p08dAl83DgOySH903y5TAAMr0DrY+N6IZ5CGWOBsdNWjnWScGH3TjPaS6cqTniOcBozAn2BVxyHPEKNF64hhtemADP8Xa/giPu8s0VnuoGj3zEIAwDlRAJiqXlqjskJFLKuJIp0VRdUiYgcljBo1rFluCT59bfqAsxiQgzSlWC/GXyv3YKmSjOxqG8R1WylR0EnRdmYPDCPZi88ACPTxx/fgGwOGEuJ+v1Tc3fy+n9sLvx56Iab/harr5/Gvldb/5ytgVKPyWWv2qU4gAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCross);
export default __webpack_public_path__ + "static/media/modalCross.ec5f52aa3bfce6c878b0dfde45830941.svg";
export { ForwardRef as ReactComponent };